module.exports = __webpack_public_path__ + "img/bossoffice.57924844.jpg";